import React from 'react';
import { colors, fonts, sectionLabelStyle, gradients } from './styles';
import { Highlight } from './Highlight';

const stats = [
  { number: '1–2', label: 'advisory boards per year at many organizations' },
  { number: '6–10', label: 'patients reached per advisory board' },
  { number: 'Months', label: 'to design, field, and report a bespoke study' },
];

export const ProblemSection = () => {
  return (
    <section
      style={{
        backgroundColor: colors.white,
        padding: '96px 48px',
        boxSizing: 'border-box',
      }}
    >
      <style>{`
        @media (max-width: 768px) {
          .pi-problem-wrap { padding-left: 24px !important; padding-right: 24px !important; padding-top: 64px !important; padding-bottom: 64px !important; }
          .pi-stat-boxes { grid-template-columns: 1fr !important; }
        }
        .pi-br-md { display: none; }
        @media (min-width: 768px) { .pi-br-md { display: inline; } }
      `}</style>
      <div className="pi-problem-wrap" style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <div style={{ maxWidth: '920px', margin: '0 auto', textAlign: 'center' }}>
          <p style={{ ...sectionLabelStyle, textAlign: 'center' }}>The problem</p>
          <h2
            style={{
              fontFamily: fonts.serif,
              fontSize: 'clamp(28px, 3.5vw, 44px)',
              fontWeight: 700,
              lineHeight: 1.2,
              color: colors.charcoal,
              margin: '0 0 24px',
            }}
          >
            The patient experience is transforming.
            <br />
            <span style={{ fontStyle: 'italic', fontWeight: 400 }}>
              Most <Highlight>intelligence</Highlight> about it isn't.
            </span>
          </h2>
          <p
            style={{
              fontFamily: fonts.sans,
              fontSize: '17px',
              lineHeight: 1.75,
              color: colors.warmGray,
              maxWidth: '640px',
              margin: '0 auto 16px',
              fontWeight: 400,
            }}
          >
            Care pathways are shifting. Treatment options are multiplying. Patient expectations are shaped by technology, by social media, by stories spreading across patient communities — and teams under pressure are turning to AI for fast answers.
          </p>
          <p
            style={{
              fontFamily: fonts.sans,
              fontSize: '18px',
              lineHeight: 1.65,
              color: colors.charcoal,
              maxWidth: '640px',
              margin: '0 auto 56px',
              fontWeight: 500,
            }}
          >
            But speed without verified patient voice isn't intelligence.{' '}
            <em style={{ fontStyle: 'italic', color: colors.terracotta, fontWeight: 600 }}>It's inference.</em>
          </p>
        </div>

        <div
          style={{
            border: `1px solid ${colors.border}`,
            borderRadius: '10px',
            overflow: 'hidden',
            margin: '0 auto 40px',
            maxWidth: '780px',
          }}
        >
          <div
            style={{
              fontFamily: fonts.sans,
              fontSize: '11px',
              fontWeight: 600,
              letterSpacing: '1.5px',
              textTransform: 'uppercase',
              color: colors.warmGray,
              backgroundColor: '#EDE8E2',
              padding: '14px 32px',
              borderBottom: `1px solid ${colors.border}`,
              textAlign: 'center',
            }}
          >
            The traditional patient voice model
          </div>
          <div
            className="pi-stat-boxes"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '1px',
              backgroundColor: colors.border,
            }}
          >
            {stats.map((s) => (
              <div key={s.label} style={{ backgroundColor: colors.white, padding: '20px 20px', textAlign: 'center' }}>
                <div
                  style={{
                    fontFamily: fonts.serif,
                    fontSize: '22px',
                    fontWeight: 700,
                    color: colors.charcoal,
                    lineHeight: 1.1,
                    marginBottom: '6px',
                    letterSpacing: '-0.01em',
                  }}
                >
                  {s.number}
                </div>
                <div
                  style={{
                    fontFamily: fonts.sans,
                    fontSize: '13px',
                    color: colors.warmGray,
                    lineHeight: 1.45,
                    fontWeight: 400,
                    maxWidth: '240px',
                    margin: '0 auto',
                    textWrap: 'pretty',
                  }}
                >
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ maxWidth: '760px', margin: '0 auto', textAlign: 'center' }}>
          <p
            style={{
              fontFamily: fonts.sans,
              fontSize: '17px',
              color: colors.warmGray,
              lineHeight: 1.7,
              margin: '0 auto 32px',
              fontWeight: 400,
              maxWidth: '640px',
            }}
          >
            By the time findings are reported, the decision is already made —<br className="pi-br-md" />
            {' '}
            <em style={{ fontStyle: 'italic', color: colors.charcoal, fontWeight: 500 }}>
              and the patient experience has <Highlight>already moved on</Highlight>.
            </em>
          </p>
          <div
            style={{
              background: gradients.primarySoft,
              padding: '28px 32px',
              borderRadius: '10px',
              maxWidth: '680px',
              margin: '0 auto',
              border: `1px solid rgba(235,160,155,0.25)`,
            }}
          >
            <p
              style={{
                fontFamily: fonts.serif,
                fontSize: '18px',
                lineHeight: 1.55,
                color: colors.charcoal,
                fontStyle: 'italic',
                margin: 0,
                fontWeight: 500,
              }}
            >
              Traditional research wasn't designed for the <Highlight>pace of decisions</Highlight><br className="pi-br-md" />
              {' '}pharma teams are actually making today.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
